import { render, staticRenderFns } from "./ProductsFromOrder.vue?vue&type=template&id=ff5aa762&"
import script from "./ProductsFromOrder.vue?vue&type=script&lang=js&"
export * from "./ProductsFromOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports